export const isValidpostalCode = (value: any) => /^[1-9][0-9]{3}\s*[a-z]{2}$/i.test(value);
export const isNumber = (value: any) => !isNaN(Number(value));
export const isEmail = (value: any) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
        value,
    );
export const isValidDate = (value: any) =>
    /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/.test(value);
